import { useSelector } from 'react-redux';

import { selectCompany, selectCompanyRegistration } from '@legacy-redux/preferences/selectors';

import { Menu, MenuItem, MenuSection } from '@shared/layout/components/Menu';

export function CompanyMenu() {
  const company = useSelector(selectCompany);
  const registration = useSelector(selectCompanyRegistration);

  const limitsComplete =
    registration &&
    ['created', 'crewQuantityRequested', 'crewQuantityWaitingForApproval', 'rejected'].indexOf(
      registration.status.name
    ) === -1;

  if (!company || (!company.crewAdmin && !company.materialAdmin && !company.gatekeepingAdmin)) {
    return null;
  }

  return (
    <Menu>
      <MenuSection icon="line-graph" title="Dashboard" to="/dashboard" />
      <MenuSection icon="notes" title="Company">
        <MenuItem title="Company Info" to="/company" />
        <MenuItem title="Crew Database" to="/company/employees" />
        <MenuItem title="Safety Questions" to="/company/security-questions" />
      </MenuSection>
      {Boolean(company.crewAdmin) && (
        <>
          <MenuSection icon="calendar" title="Crew">
            <MenuItem title="Planning" to="/crew/planning" />
            <MenuItem
              title="Crew Members"
              to="/crew/crewmembers"
              disabled={!limitsComplete}
              tip={!limitsComplete ? 'This will be available when your planning has been approved' : ''}
            />
            <MenuItem
              title="Catering"
              to="/catering"
              disabled={!limitsComplete}
              tip={!limitsComplete ? 'This will be available when your planning has been approved' : ''}
            />
            <MenuItem
              title="Parking"
              to="/parking"
              disabled={!limitsComplete}
              tip={!limitsComplete ? 'This will be available when your planning has been approved' : ''}
            />
          </MenuSection>
        </>
      )}
      {Boolean(company.materialAdmin) && <MenuSection icon="walkie" title="Materials" to="/materials" />}
      {Boolean(company.gatekeepingAdmin) && <MenuSection icon="truck" title="Gatekeeping" to="/gatekeeping" />}
      {Boolean(registration?.canSeeFrequentPassageRequests && (company.gatekeepingAdmin || company.crewAdmin)) && (
        <MenuSection icon="truck" title="Frequent Passages" to="/frequent-passage-requests" />
      )}
    </Menu>
  );
}
